import { c as _c } from "react/compiler-runtime";
import { ApiGroupFilterDirection } from "@/generated/models/ApiGroupFilterDirection";
import type { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonTabs from "@/components/utils/select/tabs/CommonTabs";
export default function GroupCreateDirection(t0) {
  const $ = _c(11);
  const {
    direction,
    label,
    setDirection
  } = t0;
  const t1 = `${label} to`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      label: t1,
      value: ApiGroupFilterDirection.Sent,
      key: ApiGroupFilterDirection.Sent
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${label} from`;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      label: t3,
      value: ApiGroupFilterDirection.Received,
      key: ApiGroupFilterDirection.Received
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = [t2, t4];
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const items = t5;
  let t6;
  if ($[7] !== direction || $[8] !== items || $[9] !== setDirection) {
    t6 = <CommonTabs items={items} activeItem={direction} filterLabel="Identity Direction" setSelected={setDirection} />;
    $[7] = direction;
    $[8] = items;
    $[9] = setDirection;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}